import React, { useState } from "react"
import { Button, Col, Form, Row, InputGroup } from "react-bootstrap"
import _ from "lodash"

import { categoryNameError } from "@/pricing/models/CategoryName"

const AddRateCategory = ({ rateCategories, onClick }): JSX.Element => {
  const [newRateCtg, setNewRateCtg] = useState("")
  const [rateTypeError, setRateTypeError] = useState("")

  const noRatesDefined = _.isEmpty(rateCategories)

  const addRateCategory = (ctg) => {
    const error = categoryNameError(ctg, rateCategories)

    setRateTypeError(error || "")
    if (error) return

    onClick(ctg)
    setNewRateCtg("")
  }

  return (
    <Form.Group as={Row}>
      {noRatesDefined && (
        <Col xs={12} className="mb-2">
          <small>
            <i>Enter a singular name for the category of the rate below (ex. adult or child)</i>
          </small>
        </Col>
      )}
      <Col md={4}>
        <InputGroup hasValidation>
          <Form.Control
            value={newRateCtg}
            onChange={(e) => {
              setNewRateCtg(e.target.value)
              setRateTypeError("")
            }}
            isInvalid={rateTypeError !== "" ? true : undefined}
          />
          <Form.Control.Feedback type="invalid">{rateTypeError}</Form.Control.Feedback>
        </InputGroup>
      </Col>
      <Col md={8}>
        <Button size="sm" onClick={() => addRateCategory(newRateCtg)}>
          <i className="fas fa-plus me-2" />
          Category
        </Button>
      </Col>
    </Form.Group>
  )
}

export default AddRateCategory
